module.exports = __webpack_public_path__ + "media/images/icon-warning-c8ff555e84903529a03719a7c214026a.svg";